import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import o, { useRef as n, useEffect as a } from "react";
var t = {
  justNow: "Just now",
  aFewSecondsAgo: "A few seconds ago",
  secondsAgo: "seconds ago",
  aMinuteAgo: "A minute ago",
  minutesAgo: "minutes ago",
  anHourAgo: "An hour ago",
  hoursAgo: "hours ago",
  aDayAgo: "A day ago",
  daysAgo: "days ago",
  aWeekAgo: "A week ago",
  weeksAgo: "weeks ago",
  aMonthAgo: "A month ago",
  monthsAgo: "months ago",
  aYearAgo: "A year ago",
  yearsAgo: "years ago"
};

function e(o, n) {
  return function (o) {
    if (Array.isArray(o)) return o;
  }(o) || function (o, n) {
    var a = [],
        t = !0,
        e = !1,
        r = void 0;

    try {
      for (var c, u = o[Symbol.iterator](); !(t = (c = u.next()).done) && (a.push(c.value), !n || a.length !== n); t = !0) {
        ;
      }
    } catch (o) {
      e = !0, r = o;
    } finally {
      try {
        t || null == u.return || u.return();
      } finally {
        if (e) throw r;
      }
    }

    return a;
  }(o, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

var r = function r(_r) {
  var c,
      u,
      g,
      s = _r.date,
      i = void 0 === s ? new Date() : s,
      A = _r.config,
      h = void 0 === A ? t : A,
      f = e(o.useState(i), 2),
      d = f[0],
      l = (f[1], e(o.useState(new Date() - d), 2)),
      y = l[0],
      m = l[1];
  return c = function c() {
    m(new Date() - d);
  }, u = 5e3, g = n(), a(function () {
    g.current = c;
  }, [c]), a(function () {
    if (null !== u) {
      var o = setInterval(function () {
        g.current();
      }, u);
      return function () {
        return clearInterval(o);
      };
    }
  }, [u]), function (o, n) {
    o < 0 && (o = -o);
    var a = {
      year: Math.floor(o / 31536e6),
      month: Math.floor(o / 2592e6) % 365,
      day: Math.floor(o / 864e5) % 30,
      week: Math.floor(o / 6048e5) % 7,
      hour: Math.floor(o / 36e5) % 24,
      minute: Math.floor(o / 6e4) % 60,
      second: Math.floor(o / 1e3) % 60,
      millisecond: Math.floor(o) % 1e3
    };
    return a.year > 1 ? "".concat(a.year, " ").concat(n.yearsAgo) : 1 == a.year ? "".concat(n.aYearAgo) : a.month > 1 ? "".concat(a.month, " ").concat(n.monthsAgo) : 1 == a.month ? "".concat(n.aMonthAgo) : a.week > 1 ? "".concat(a.week, " ").concat(n.weeksAgo) : 1 == a.week ? "".concat(n.aWeekAgo) : a.day > 1 ? "".concat(a.day, " ").concat(n.daysAgo) : 1 == a.day ? "".concat(n.aDayAgo) : a.hour > 1 ? "".concat(a.hour, " ").concat(n.hoursAgo) : 1 == a.hour ? "".concat(n.anHourAgo) : a.minute > 1 ? "".concat(a.minute, " ").concat(n.minutesAgo) : 1 == a.minute ? "".concat(n.aMinuteAgo) : a.second >= 30 ? "".concat(a.second, " ").concat(n.secondsAgo) : "".concat(a.second >= 15 ? n.aFewSecondsAgo : n.justNow);
  }(y, h);
};

export { r as Timy, t as formatConfig };